export const ZERO_WIDTH_SPACE = '\u200b';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const ZERO_WIDTH_JOINER = '\u200d';
